import React from "react";
import { Stack } from "@mui/material";
import FileUploaderDropZone from "Global/Components/CommonComponents/FileUploaderDropDown/FileUploaderDropZone";
import ImageEdtior from "Global/Components/CommonComponents/FileUploaderDropDown/components/ImageEditor/ImageEdtior";
const EditablePictureBoxWithEditor = ({
  onChange,
  element,
  initialImage,
  field,
}) => {
  const [stateLift, setStateLift] = React.useState();
  const [onFileContentChanges, setOnFileContentChanges] = React.useState(null);

  return (
    <React.Fragment>
      <Stack>
        <FileUploaderDropZone
          onChange={onChange}
          label={element?.LablelNameForWeb}
          isEnglish={true}
          stateLift={setStateLift}
          onFileContentChanges={onFileContentChanges}
          initialImage={initialImage}
          initialName={field?.name}
        />
        <div id="editor_container">
          <ImageEdtior
            disabled={false}
            content={stateLift}
            setOnFileContentChanges={setOnFileContentChanges}
          />
        </div>
      </Stack>
    </React.Fragment>
  );
};

export default EditablePictureBoxWithEditor;
